var Uploader = require('uploader');
var Dialog = require('../../lib/dialog.js');

module.exports = function() {
  var picker = $('#picker');
  var activeKey = null;

  // Function for handling when colours are changed
  var colourSelector = function(hsb, hex) {
    if (null !== activeKey) {
      save(hex);
    }
  };

  // Saves the selected colour to the hidden input field
  var save = function(colour) {
    var input = getInput(activeKey);

    colour = colour.replace('#', '');

    input.val(colour);

    if (colour.length) {
      $('#colour-' + activeKey).css({ background: '#' + colour });
    }
    else {
      $('#colour-' + activeKey).css({ background: '' })
    }
  };

  // Returns the hidden input for the theme colour
  var getInput = function(id) {
    return $('#input-' + id);
  };

  // Setup the picker which will be used by all
  picker.colpick({
    flat: true,
    layout:'hex',
    onSubmit: colourSelector
  });

  // When a given colour setting is clicked, load up the colour and other data, and enable the picker
  $(".colour-theme-setting").click(function() {
    activeKey = $(this).data('key');

    picker.colpickSetColor(getInput(activeKey).val());
  });

  $('.reset').click(function() {
    activeKey = $(this).data('key');

    // reset it
    save('');
  });

  var resetAll = function() {
    $('.colour').css({ background: '' });
    $('input[name^="theme"].theme-colour-option').val('');
  }

  var dialog = new Dialog();

  $('.reset-all').click(function() {
    dialog.show({ content: $(this).data('warning') }, resetAll);
  });

  // Setup the Uploader, if included on the page.
  if ($("#uploader").length > 0) {
    new Uploader(uploaderOptions.clarify());
  }
};
